// Sample texts wired to the "Try an example" buttons.
// SAMPLE_REDFLAG is the romance-fraud script (formerly SAMPLE_SCAM).
// SAMPLE_HEALTHY is the normal early-dating exchange.

export const SAMPLE_REDFLAG = {
  mode: "full",
  profile: `Hi there, I am James. I am 57 years old and I work as a civil engineer on a contract in Aberdeen, Scotland. I was married for 22 years to my late wife Sandra who passed away from cancer in 2019. I have one son who is in college in Atlanta. I am a God-fearing man who believes in honesty and family values. I am not very active on this site so if you want to reach me faster please message me on Google Hangouts at james.b.civil@gmail.com. Looking for my forever partner.`,
  conversation: `Him: Hello beautiful, your smile caught my eye right away.
Her: Thanks, how are you?
Him: I am doing well by God's grace. You seem like a very special woman. I feel like we have a strong connection already. Can we talk on Hangouts? I am not often on this site.
Her: Maybe later. I'd rather stay here for now.
Him: I understand, but this app is difficult for me. My camera is broken right now because of work, but I know you are a good woman. I hate to ask, but my bank card has a problem while I am overseas. Could you help me with a small gift card? I promise I will pay you back.`,
};

export const SAMPLE_HEALTHY = {
  mode: "full",
  profile: `Sandra, 54, retired teacher from Austin. My kids are grown and I'm rediscovering what I actually like to do — hiking, terrible cooking, and watching too many documentaries. Looking for someone to have dinner with and see what happens. Not looking to rush anything.`,
  conversation: `Him: I liked your bit about terrible cooking. What's the worst thing you've ever made?
Her: Oh lord. Attempted chicken tikka masala from scratch. It was essentially orange paste.
Him: Ha. I once set off the smoke alarm making toast. We might be a good match.
Her: Are you in Austin?
Him: Yeah, Buda actually. You teach locally or did you commute?
Her: I taught in Austin for years. I'm fine chatting here for a bit. If we both feel comfortable, maybe coffee somewhere public next week.`,
};

export const buildFull = (s) =>
  `PROFILE:\n${s.profile}\n\nCONVERSATION:\n${s.conversation}`;
